export const localStorageKey = "lastConnectedWalletType";
